import GML2 from './gml/gml2.js';
import GML311 from './gml/gml311.js';
import GML32 from './gml/gml32.js';

const getGMLFeatures = (text) => {
	const document = new DOMParser().parseFromString(text, 'application/xml');
   	const readers = [ new GML32(), new GML311(), new GML2() ];
   	
   	for( let i = 0; i < readers.length; i++ ) {
		if( readers[i].is_valid(document.documentElement) ) {
			return readers[i].read(document.documentElement);
		}	
    }
    
    return null;
}

const gml = async (reader) => {
	const buffer = await reader.read(0);
	
	const decoder = new TextDecoder(); // always utf-8
	const text = decoder.decode(buffer);
	
	return getGMLFeatures(text);
}

export {
	gml
}